import { cliftonConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function CliftonPage() {
  return <CityPageTemplate config={cliftonConfig} />;
}